import React from 'react'
import { Formik, Form, Field } from 'formik'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import Swal from 'sweetalert2'

const url = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_URL
  : process.env.REACT_APP_URL_DEV

const BRAND = '#6eb446'

interface Props {
  _stripe       : string
  _payeremail   : string
  marketing     : string
  set_stripe    : (v: string) => void
  set_payeremail: (v: string) => void
  setmarketing  : (v: string) => void
  setLoading    : (v: boolean) => void
  usertypes     : string
  perPage       : number
  setData       : (data: any[]) => void
  setTotalRows  : (n: number) => void
  getHeaders    : () => Promise<Record<string, string>>
}

interface FormValues {
  stripe    : string
  payeremail: string
  marketing : string
}

const MarketingForm: React.FC<Props> = ({
  _stripe: stripe, _payeremail: payeremail, marketing,
  set_stripe: setStripe, set_payeremail: setPayeremail, setmarketing: setMarketing,
  setLoading, usertypes, perPage,
  setData, setTotalRows, getHeaders,
}) => {
  const { t } = useTranslation()

  const handleSearch = async (values: FormValues) => {
    setStripe(values.stripe)
    setPayeremail(values.payeremail)
    setMarketing(values.marketing)
    setLoading(true)
    try {
      const headers = await getHeaders()
      const res     = await axios.get(
        `${url}payments/admin/${usertypes}?page=1&per_page=${perPage}&stripe=${values.stripe}&payeremail=${values.payeremail}&marketing=${values.marketing}`,
        { headers }
      )
      setData(res.data.message)
      setTotalRows(res.data.total)
    } catch (err: any) {
      Swal.fire({ icon: 'error', title: err?.response?.data?.response || 'Error' })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Formik
      initialValues={{ stripe, payeremail, marketing }}
      onSubmit={handleSearch}
      enableReinitialize
    >
      <Form>
        <div className="row align-items-center mb-3">
          <label className="col-sm-2 col-form-label col-form-label-sm">
            {t('payments.admin.stripe_data')}
          </label>
          <div className="col-sm-10">
            <Field
              type="text"
              className="form-control form-control-sm"
              placeholder={t('payments.admin.stripe_data')}
              name="stripe"
            />
          </div>
        </div>

        <div className="row align-items-center mb-3">
          <label className="col-sm-2 col-form-label col-form-label-sm">
            {t('payments.admin.payer_email')}
          </label>
          <div className="col-sm-10">
            <Field
              type="text"
              className="form-control form-control-sm"
              placeholder={t('payments.admin.payer_email')}
              name="payeremail"
            />
          </div>
        </div>

        <div className="row align-items-center mb-3">
          <label className="col-sm-2 col-form-label col-form-label-sm">
            {t('payments.admin.marketing_data')}
          </label>
          <div className="col-sm-10">
            <Field
              type="text"
              className="form-control form-control-sm"
              placeholder={t('payments.admin.marketing_data')}
              name="marketing"
            />
          </div>
        </div>

        <div className="mt-3">
          <button
            type="submit"
            style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', padding: '0.3rem 1rem', borderRadius: 9999, backgroundColor: BRAND, color: '#fff', fontWeight: 700, fontSize: '0.8rem', border: 'none', cursor: 'pointer' }}
          >
            <FontAwesomeIcon icon={faMagnifyingGlass} />
            <span>{t('utilities.search_btn')}</span>
          </button>
        </div>
      </Form>
    </Formik>
  )
}

export default MarketingForm
